"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IconButtonRedirect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customProps = require("../../../../utils/customProps");

var _appRedirect = _interopRequireDefault(require("../../../../utils/appRedirect"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

/**
 * IconButtonRedirect is used in storyblok redirect to react routes
 */
var IconButtonRedirect = function IconButtonRedirect(_ref) {
  var href = _ref.href,
      iconButton = _ref.iconButton,
      external = _ref.external,
      callback = _ref.callback;

  var externalRedirect = function externalRedirect() {
    window.location.replace(href);
  };

  var internalRedirect = function internalRedirect() {
    (0, _appRedirect.default)(href);
  };

  var onClick = function onClick() {
    if (callback) callback();

    if (external) {
      return externalRedirect();
    }

    return internalRedirect(href);
  };

  var btn = iconButton[0];
  return /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({}, btn, {
    onClick: onClick
  }));
};

exports.IconButtonRedirect = IconButtonRedirect;
var _default = IconButtonRedirect;
exports.default = _default;
IconButtonRedirect.propTypes = {
  /** redirect route */
  href: _propTypes.default.string.isRequired,

  /** IconButton Allowed maximum: 1 */
  iconButton: function iconButton(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['IconButton'], 1);
  },

  /**
   * If checked you will be directed to another website (ex: ‘https://google.com’)
   *  If unchecked you will be directed to a page on your site (ex: ‘.page-welcome’)
   * */
  external: _propTypes.default.bool,
  // callback to run before redirect
  callback: _propTypes.default.func
};
IconButtonRedirect.defaultProps = {
  iconButton: [],
  callback: undefined,
  external: false
};